// extracted by mini-css-extract-plugin
module.exports = {"container":"UserInfo_container__7debA","bubble":"UserInfo_bubble__2ksoj","user":"UserInfo_user__2e5qy"};